import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'mediaValidity',
})
export class MediaValidityPipe implements PipeTransform {
  transform(validityEndDate: Date | null | undefined): boolean {
    if (!validityEndDate) return true;

    const today: moment.Moment = moment.utc(new Date());
    const validityDate: moment.Moment = moment.utc(validityEndDate);

    return validityDate >= today;
  }
}
